import { useState, useEffect } from 'react';
import {
  initializeCurrencyRates,
  detectUserCurrency,
  BASE_CURRENCY,
  CURRENCIES,
  convertPrice as convertPriceUtil,
  formatCurrency
} from '../utils/currencyUtils';

export const useCurrency = () => {
  const [currencyRates, setCurrencyRates] = useState(CURRENCIES);
  const [selectedCurrency, setSelectedCurrency] = useState(BASE_CURRENCY);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCurrencyData = async () => {
      setIsLoading(true);
      try {
        const rates = await initializeCurrencyRates();
        setCurrencyRates(rates);
        
        // Auto-detect user's preferred currency
        const userCurrency = detectUserCurrency();
        setSelectedCurrency(userCurrency);
      } catch (error) {
        console.error('Failed to load currency data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCurrencyData();
  }, []);

  const convertPrice = (inrAmount) => {
    return convertPriceUtil(inrAmount, selectedCurrency, currencyRates);
  };

  // Get currency object by code
  const getCurrency = (code) => CURRENCIES[code] || CURRENCIES[BASE_CURRENCY];

  // Format amount with specific currency
  const formatWithCurrency = (amount, currencyCode, showSymbol = true) => {
    return formatCurrency(amount, currencyCode, showSymbol);
  };

  const formatPrice = (inrAmount, showSymbol = true) => {
    const converted = convertPrice(inrAmount);
    return formatCurrency(converted, selectedCurrency, showSymbol);
  };

  return {
    currencyRates,
    selectedCurrency,
    setSelectedCurrency,
    isLoading,
    convertPrice,
    formatPrice,
    BASE_CURRENCY,
    BASE_CURRENCY_SYMBOL: CURRENCIES[BASE_CURRENCY]?.symbol || '₹',
    CURRENCIES: Object.values(CURRENCIES),
    currencySymbol: getCurrency(selectedCurrency).symbol,
	getCurrency,
    formatWithCurrency
  };
};